import { useEffect } from "react";
import * as THREE from "three";
import { getSavedCameraWorldPose } from "../../utils/savedCameraWorldPose";
import { EMPTY_OBJECT, SAVED_CAMERA_MARKERS_GROUP_NAME } from "../scene/sceneConstants";
import { disposeSceneObjectTree } from "../scene/sceneDispose";
import { createSavedCameraMarker } from "../scene/savedCameraMarker";

export function useSavedCameraMarkers({
  allSites,
  modelGroupRef,
  safeBodies,
  savedCameras,
  sceneObjectsRef,
  sceneRef,
  showSavedCameraMarkers,
  structureChangeTick,
}) {
  useEffect(() => {
    const scene = sceneRef.current;
    if (!scene) return undefined;

    const removeMarkers = () => {
      const existing = scene.getObjectByName(SAVED_CAMERA_MARKERS_GROUP_NAME);
      if (!existing) return;
      existing.parent?.remove(existing);
      disposeSceneObjectTree(existing);
    };

    removeMarkers();
    if (!showSavedCameraMarkers) return undefined;

    const cameras = Object.values(savedCameras || EMPTY_OBJECT).filter(Boolean);
    if (cameras.length === 0) return undefined;

    const root = new THREE.Group();
    root.name = SAVED_CAMERA_MARKERS_GROUP_NAME;
    root.userData = { isSavedCameraMarkersRoot: true };
    scene.add(root);

    cameras.forEach((cameraDef) => {
      const marker = createSavedCameraMarker(cameraDef);
      const pose = getSavedCameraWorldPose(
        cameraDef,
        sceneObjectsRef.current,
        safeBodies,
        allSites || EMPTY_OBJECT,
        scene.getObjectByName("modelGroup") || modelGroupRef.current || null
      );
      marker.position.copy(pose.position);
      marker.quaternion.copy(pose.quaternion);
      root.add(marker);
    });

    return removeMarkers;
  }, [
    showSavedCameraMarkers,
    savedCameras,
    safeBodies,
    allSites,
    structureChangeTick,
    sceneRef,
    sceneObjectsRef,
    modelGroupRef,
  ]);
}
